import request from "@/utils/request";

export function testLogin(data) {
  return request({
    url: "/Login/OldStudentLogin",
    method: "post",
    data
  });
}
